import { SWITCH_VAL } from "../actions/types";

export default (val = true, action) => {
  if (action.type === SWITCH_VAL) {
    return action.payload;
  }
  return val;
};
